import { render, staticRenderFns } from "./Section01.vue?vue&type=template&id=42d51bc3&"
import script from "./Section01.vue?vue&type=script&lang=js&"
export * from "./Section01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports